import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";
import { Exam } from "../apiSlice/examSlice";
import { FilterQueryParams } from "../../forms/FilterForm";

export const getFinanceAtc = createAsyncThunk(
  "getFinanceAtc",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.financesAtc);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getFinanceAtcUser = createAsyncThunk(
  "getFinanceAtc",
  async (atc_id: string, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.financesAtc}/${atc_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getFinanceAtcFilter = createAsyncThunk(
  "getFinanceAtcFilter",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.financesAtc}/filter/?from=${queryParams.from}&to=${queryParams.to}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getFinancePublic = createAsyncThunk(
  "getFinancePublic",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.financesPublic);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getFinancePublicFilter = createAsyncThunk(
  "getFinancePublicFilter",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.financesPublic}/filter/?from=${queryParams.from}&to=${queryParams.to}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteExam = createAsyncThunk(
  "delete/requests",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(
        `${EndPoints.requestsAtc}/${id}`
      );
      dispatch(getFinanceAtc());
      return { status: response.data.status, id };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const createExam = createAsyncThunk(
  "create/requests",
  async (data: Exam, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(`${EndPoints.requestsAtc}`, data);
      dispatch(getFinanceAtc());
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateExam = createAsyncThunk(
  "update/requests",
  async (data: Exam, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.requestsAtc}/${data.id}`,
        data
      );
      dispatch(getFinanceAtc());
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
